module.exports = __webpack_public_path__ + "assets/empty.ac4a76d7.svg";